import { render, staticRenderFns } from "./DocumentDraftingDetailAprove.vue?vue&type=template&id=60567d88&scoped=true"
import script from "./DocumentDraftingDetailAprove.vue?vue&type=script&lang=js"
export * from "./DocumentDraftingDetailAprove.vue?vue&type=script&lang=js"
import style0 from "./DocumentDraftingDetailAprove.vue?vue&type=style&index=0&id=60567d88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60567d88",
  null
  
)

export default component.exports